import { useSelector, useDispatch } from "react-redux";
import { RootReducer } from "@twire/redux/types";
import { filterTournaments } from "@twire/redux/tournaments/actions";
import { filterScrims } from "@twire/redux/scrims/actions";
import { TimeType, TournamentsInterface } from "@twire/redux/tournaments/types";
import { useSelect } from "@twire/common/Select";
import { regionMap, tierMap } from "@twire/utility/constants";
import TournamentsFilter from "./TournamentsFilter";
import { TournamentsViewProps } from "../Tournaments/TournamentsView";
import { filterPpt } from "@twire/redux/ppt/actions";
import { PptInterface } from "@twire/redux/ppt/types";

const modeActions = {
  scrim: filterScrims,
  ppt: filterPpt,
  tournament: filterTournaments
};

const TournamentsFilterContainer: React.FC<{
  type: TimeType;
  mode?: TournamentsViewProps["mode"];
  pptType?: TournamentsViewProps["pptType"];
  onOpen?: (arg?: any) => void;
  onClose?: (arg?: any) => void;
}> = ({ type, mode = "tournament", pptType = 'ppt_scrim', ...rest }) => {
  const dispatch = useDispatch();
  const state = useSelector((state: RootReducer) => state);
  const isPpt = mode === 'ppt'
  const filterTournamets =
    state.tournaments.tournaments?.[
      type as keyof TournamentsInterface["requestStates"]
    ]?.filter || {};
  const scrimsFilter = state.scrims.scrims.filter || {};
  const pptsFilter = state.ppt.ppt?.[
    pptType as keyof PptInterface["requestStates"]
  ]?.filter || {};

  const filterActionMode = {
    tournament: filterTournamets,
    scrim: scrimsFilter,
    ppt: pptsFilter
  };

  const regionItems = Object.entries(regionMap).map(([value, title]) => ({
    value,
    title
  }));
  const tierItems = Object.values(tierMap).map((value) => ({
    value,
    title: `tier ${value}`
  }));

  const regionInstance = useSelect(regionItems, filterActionMode[mode]?.region);
  const tierInstance = useSelect(
    [...tierItems, ...[{ value: "", title: "all" }]],
    filterActionMode[mode]?.tier
  );

  const onApplyClicked = () => {
    dispatch(
      modeActions[mode](
        {
          region: regionInstance.value.value,
          tier: tierInstance.value.value
        },
        isPpt ? pptType : type
      )
    );
  };

  const onClearClicked = () => {
    regionInstance.updateValue({ title: "all", value: "" });
    tierInstance.updateValue({ title: "all", value: "" });
    dispatch(modeActions[mode]({ region: "", tier: "" }, isPpt ? pptType : type));
  };

  return (
    <TournamentsFilter
      regionInstance={regionInstance}
      tierInstance={tierInstance}
      onApplyClicked={onApplyClicked}
      onClearClicked={onClearClicked}
      {...rest}
    />
  );
};

export default TournamentsFilterContainer;
